// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CCryi","colBig":"styles_colBig__2rROt","colSmall":"styles_colSmall__3MUoL"};